import { Event } from '@/app/event-stream';

export const CourseOpenedEventName = 'course-opened' as const;
interface CourseOpenedEvent {
  courseId: string;
}

export const CourseLeftEventName = 'course-left' as const;
interface CourseLeftEvent {
  courseId: string;
}

export const TimeSpentInCourseEventName = 'time-spent-in-course' as const;
interface TimeSpentInCourseEvent {
  courseId: string;
}

export type CourseEvent = Event<typeof CourseOpenedEventName, CourseOpenedEvent>
  | Event<typeof CourseLeftEventName, CourseLeftEvent>
  | Event<typeof TimeSpentInCourseEventName, TimeSpentInCourseEvent>;
